import React from 'react';
import { ChipProps } from './interfaces';
import { StyledChip } from './styles';

const Chip = ({
  label,
  selected,
  cursor,
  fullWidth,
  icon,
  borderColor,
  onClick,
}: ChipProps) => {
  return (
    <StyledChip
      selected={selected}
      onClick={() => onClick?.(label)}
      cursor={cursor}
      fullWidth={fullWidth}
      borderColor={borderColor}
    >
      {label}
      {icon}
    </StyledChip>
  );
};

export default Chip;
